export type PxdbDeviceState = {
    pxdbgatewayLoading: boolean;
    pxdbgatewaySuccess: boolean;
    loading: boolean;
    success: boolean;
    errorCode: string;
    hasData: boolean;
    connectionString: string;
   
};
export const initialPxdbDevice: PxdbDeviceState = {
    pxdbgatewayLoading: false,
    pxdbgatewaySuccess: false,
    loading: false,
    success: false,
    errorCode: '',
    hasData: true,
    connectionString: '',
  
};
